import {Category} from '../../../services/models/response/CategoryResService';

export const manualItem: Category = {
  title: 'همه',
  forEvent: false,
  type: 0,
  isOnline: true,
  isKiosk: null,
  id: '',
  updatedAt: '',
  createdAt: '',
  deletedAt: null,
  image: null,
};
